import React from "react";

const VisionMission = () => {
  return (
  <div className="vm-section">
  <div className="container">

    <h2 className="vm-title">Our Vision & Mission</h2>

    <div className="vm-grid">

 {/* Vision */}
<div className="vm-card vision">
  <div className="vm-icon-box">👁️</div>
  <h3>Our Vision</h3>
  <p>
    To become the most trusted and preferred transportation service across cities by delivering safe, reliable, and innovative travel solutions. We aim to redefine urban mobility by combining technology, comfort, and efficiency to create a seamless travel experience.

    Our vision is to set new standards in the transportation industry by focusing on customer satisfaction, expanding our reach, and continuously improving our services to meet the evolving needs of modern travelers.
  </p>
</div>

{/* Mission */}
<div className="vm-card mission">
  <div className="vm-icon-box">🎯</div>
  <h3>Our Mission</h3>
  <p>
    Our mission is to provide seamless, affordable, and comfortable travel experiences through well-maintained vehicles and highly professional drivers. We are committed to punctuality, safety, and ensuring every ride is smooth and stress-free for our customers.

    We strive to build long-term relationships by offering dependable services, transparent pricing, and continuous improvements driven by customer feedback and innovation.
  </p>
</div>

    </div>
  </div>
</div>
  );
};

export default VisionMission;